interface SurgeryMenuProps {
  setDisplayValue: (val: number) => void;
  displayValue: number;
  clear: boolean;
  setClear: (val: boolean) => void;
  setIsFiltersOpen?: () => void;
}
const SurgeryMenu: React.FC<SurgeryMenuProps> = ({
  setDisplayValue,
  displayValue,
  setClear,
  clear,
  setIsFiltersOpen,
}) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setDisplayValue(Number(event.target.value));
    setClear(false);
    setIsFiltersOpen?.();
  };
  return (
    <ul>
      <li>
        <label className="label cursor-pointer justify-start ml-5">
          <input
            type="radio"
            className="radio radio-xs bg-white border-accent checked:radio-accent"
            value={26}
            checked={!clear && displayValue === 26}
            onChange={handleChange}
          />
          <span className="text-valmidnight text-base ml-2">
            Alcohol Septal Ablation
          </span>
        </label>
      </li>
      <li>
        <label className="label cursor-pointer justify-start ml-5">
          <input
            type="radio"
            className="radio radio-xs bg-white border-accent checked:radio-accent"
            value={27}
            checked={!clear && displayValue === 27}
            onChange={handleChange}
          />
          <span className="text-valmidnight text-base ml-2">
            Septal Myectomy
          </span>
        </label>
      </li>
      <li>
        <label className="label cursor-pointer justify-start ml-5">
          <input
            type="radio"
            className="radio radio-xs bg-white border-accent checked:radio-accent"
            value={28}
            checked={!clear && displayValue === 28}
            onChange={handleChange}
          />
          <span className="text-valmidnight text-base ml-2">CABG</span>
        </label>
      </li>
      <li>
        <label className="label cursor-pointer justify-start ml-5">
          <input
            type="radio"
            className="radio radio-xs bg-white border-accent checked:radio-accent"
            value={29}
            checked={!clear && displayValue === 29}
            onChange={handleChange}
          />
          <span className="text-valmidnight text-base ml-2">ICD</span>
        </label>
      </li>
      <li>
        <label className="label cursor-pointer justify-start ml-5">
          <input
            type="radio"
            className="radio radio-xs bg-white border-accent checked:radio-accent"
            value={30}
            checked={!clear && displayValue === 30}
            onChange={handleChange}
          />
          <span className="text-valmidnight text-base ml-2">
            Mitral Valve Surgery
          </span>
        </label>
      </li>
      <li>
        <label className="label cursor-pointer justify-start ml-5">
          <input
            type="radio"
            className="radio radio-xs bg-white border-accent checked:radio-accent"
            value={31}
            checked={!clear && displayValue === 31}
            onChange={handleChange}
          />
          <span className="text-valmidnight text-base ml-2">Pacemaker</span>
        </label>
      </li>
      <li>
        <label className="label cursor-pointer justify-start ml-5">
          <input
            type="radio"
            className="radio radio-xs bg-white border-accent checked:radio-accent"
            value={32}
            checked={!clear && displayValue === 32}
            onChange={handleChange}
          />
          <span className="text-valmidnight text-base ml-2">PCI</span>
        </label>
      </li>
    </ul>
  );
};

export default SurgeryMenu;
